import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight, ShieldAlert } from 'lucide-react';

/**
 * Shown on Fraud / PCC / DLC / MyTasks pages when the Operating Head has not yet
 * published (or has unpublished) the Risk Universe. Blocks downstream work.
 */
export default function RiskUnpublishedGate({ user }) {
  const role = user?.role;
  const isOH = role === 'operating_head';
  return (
    <div className="bg-white rounded-xl border border-amber-200 p-6 flex items-start gap-4" data-testid="risk-unpublished-gate">
      <div className="w-12 h-12 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0">
        <Lock className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <h3 className="text-base font-bold text-slate-900 flex items-center gap-2">
          Tasks are paused — Risk Universe not yet published
          <ShieldAlert className="w-4 h-4 text-amber-600" />
        </h3>
        <p className="text-sm text-slate-600 mt-1">
          {isOH
            ? 'Review the 45-risk universe and click "Publish Risk Universe" on the Risk Universe Setup page. Once published, PCC / Fraud / DLC tasks become active for every department.'
            : 'Your Operating Head must publish the Risk Universe before tasks for this quarter are assigned. Please check back shortly or reach out to your Operating Head.'}
        </p>
        <Link
          to="/risk"
          data-testid="gate-goto-risk"
          className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold text-[#CC0000] hover:underline"
        >
          {isOH ? 'Go to Risk Universe to publish' : 'View Risk Universe (read-only)'} <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
